<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} USER</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <!-- USERNAME & PASSWORD -->
        <vs-input :disabled="this.data.uuid" label="Username/用户代号*" v-model="username" class="w-full" name="username" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('username')">{{ errors.first('username') }}</span>
        <vs-input v-if="!this.data.uuid" label="Password/密码*" v-model="password" type="password" class="mt-5 w-full" name="password" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>

        <!-- NAME -->
        <vs-input label="Name/名字*" @keyup="uppercase" v-model="name" class="w-full" :class="{ 'mt-5' : !this.data.uuid }" name="name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>

        <!-- User Level -->
        <vs-select autocomplete v-model="role" label="Level/级别*" class="mt-5 w-full" name="role" v-validate="'required'">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in level_option" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('role')">{{ errors.first('role') }}</span>

        <div v-show="(user_info.role == 'SUPERADMIN' || user_info.role == 'PARTNER' ) && role == 'WORKER' ">
          <vs-select autocomplete v-model="groupid" label="上线" class="w-full mb-2" v-if="user_info.role == 'SUPERADMIN' || user_info.role == 'DEVELOPER' ">
            <vs-select-item :key="index" :value="item.groupid" :text="item.name" v-for="(item,index) in groupid_list" />
          </vs-select>
          <div style="display:flex" class="mb-2" v-else>
            <vs-input disabled readonly label="GroupId" v-model="groupid" class="w-1/2" />
            <vs-input disabled readonly label="Parent" v-model="parent_name" class="w-1/2" />
          </div>
        </div>

        <!-- Company Code -->
        <vs-textarea label="Company Code/公司代号" v-model="company_code" class="mt-5 w-full" />

        <!-- Group Code -->
        <!-- <vs-textarea label="Company Code/公司代号" v-model="group_code" class="mt-5 w-full" /> -->

        <!-- Contact 1 -->
        <vs-input label="Contact No/电话号码*" v-model="primary_contact" class="mt-5 w-full" name="primary_contact" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('primary_contact')">{{ errors.first('primary_contact') }}</span>

        <!-- Contact 2 -->
        <vs-input label="Other Contact No/其他电话号码" v-model="secondary_contact" class="mt-5 w-full" name="secondary_contact" />

        <!-- Email -->
        <vs-input label="Email/电邮" v-model="email" class="mt-5 w-full" name="email" />

        <!-- Remark -->
        <vs-textarea label="Remark/备忘录" v-model="remark" class="mt-5 w-full" />

        <!-- Status -->
        <vs-select autocomplete v-model="status" label="Status" class="mt-5 w-full">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in status_option" />
        </vs-select>

        <vs-divider v-if="role !== 'SUPERADMIN' " />


        <h5 v-if="role !== 'SUPERADMIN' " class="mb-2 w-full">Permission</h5>
        <!-- <div v-if="role == 'SUPERADMIN' || role == 'PARTNER' ">
          ALL PERMISSION GRANTED
        </div> -->
        <vs-select v-if="role !== 'SUPERADMIN' " autocomplete multiple v-model="permissions" label="Permission" class="w-full mb-2">
          <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in options" />
        </vs-select>
        <!-- <v-select v-else class="w-full" multiple :closeOnSelect="false" v-model="permissions" label="name" :reduce="options => options.id" :options="options" /> -->
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <!-- :disabled="!isFormValid" -->
      <vs-button v-show="permissions_update" class="mr-6" @click="submitData" :disabled="!isFormValid">{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
  },
  data () {
    return {
      // permissions_list: [],
      options: [
        {
          id:'011',
          name: 'create_user'
        },
        {
          id:'012',
          name: 'read_user'
        },
        {
          id:'013',
          name: 'update_user'
        },
        {
          id:'014',
          name: 'delete_user'
        },
        {
          id:'021',
          name: 'create_customer'
        },
        {
          id:'022',
          name: 'read_customer'
        },
        {
          id:'023',
          name: 'update_customer'
        },
        {
          id:'024',
          name: 'delete_customer'
        },
        {
          id:'031',
          name: 'create_loan'
        },
        {
          id:'032',
          name: 'read_loan'
        },
        {
          id:'033',
          name: 'edit_loan'
        },
        {
          id:'034',
          name: 'delete_loan'
        },
      ],
      created_at: '',
      deleted_at: '',
      updated_at: '',
      uuid: '',
      groupid: '',
      parent_name: '',
      company_code: '',
      email: '',
      group_code: '',
      name: '',
      username: '',
      password: '',
      permissions: [],
      primary_contact: '',
      remark: '',
      role: '',
      secondary_contact: '',
      status: '',
      switch_locked_user: false,
      switch_locked_customer: false,
      switch_locked_loan: false,
      checkBox1: [],

      status_option: [
        {text:'ACTIVE', value:'ACTIVE'},
        {text:'INACTIVE', value:'INACTIVE'}
      ],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      // if (!val) return
      // if (Object.entries(this.data).length === 0) {
      //   this.initValues()
      //   this.$validator.reset()
      // } else {

      //   let data = JSON.parse(JSON.stringify(this.data))

      //   this.created_at = data.created_at
      //   this.deleted_at = data.deleted_at
      //   this.updated_at = data.updated_at
      //   this.uuid = data.uuid
      //   this.company_code = data.company_code
      //   this.email = data.email
      //   this.group_code = data.group_code
      //   this.name = data.name
      //   this.permissions = data.permissions
      //   this.primary_contact = data.primary_contact
      //   this.remark = data.remark
      //   this.role = data.role
      //   this.secondary_contact = data.secondary_contact
      //   this.status = data.status

      //   this.initValues()
      // }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    },
  },
  computed: {
    level_option(){
      let default_lvl_option = [
        {text:'SUPERADMIN', value:'SUPERADMIN'},
        {text:'PARTNER', value:'PARTNER'},
        {text:'WORKER', value:'WORKER'}
      ]
      if(this.user_info.role == 'PARTNER'){
        default_lvl_option = [
          // {text:'SUPERADMIN', value:'SUPERADMIN'},
          // {text:'PARTNER', value:'PARTNER'},
          {text:'WORKER', value:'WORKER'}
        ]
      }
      return default_lvl_option
    },
    users () {
      return this.$store.state.userManagement.users
    },
    user_info(){
      let data = JSON.parse(sessionStorage.getItem('userInfo'));
      return data
    },
    groupid_list(){
      let self = this
      let temp = []

      this.users.forEach(function(item){
        if(item.role !== 'WORKER'){
          temp.push({
            groupid: item.groupid,
            name: item.name
          })
        }
      })

      return temp
    },
    users_filtered(){
      let self = this
      let temp = []
      if(this.users && this.user_info){
        this.users.forEach(function(item){
          // console.log(item.uuid, self.data.uuid)
          if(item.uuid !== self.data.uuid){
            temp.push(item)
          }
        })
      }
      
      return temp
    },
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      if(this.data.uuid){
        return !this.errors.any() && this.name && this.role && this.primary_contact
      }
      else{
        return !this.errors.any() && this.name && this.role && this.primary_contact && this.username && this.password
      }      
    },
    computed_permissions () {
      if(this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.permissions){
        return this.$store.state.AppActiveUser.permissions;
      }
      else{
        return []
      }
    },
    permissions_update(){
      if( this.computed_permissions.includes('*') || this.computed_permissions.includes('013')){
        return true
      }
      else{
        return false
      }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    uppercase() {
      this.name = this.name.toUpperCase();
    },
    filterUser(){
      let temp = []
      this.users.forEach(function(item){
        if(item.id !== this.user_info.id){
          temp.push(item)
        }
      })
      return temp
      // return this.users.filter(item => item.id !== this.user_info.id);
    },
    initValues () {
      if (this.data.uuid) return

      this.created_at = ''
      this.deleted_at = ''
      this.updated_at = ''
      this.groupid = this.user_info.group
      this.parent_name = this.user_info.name
      this.uuid = ''
      this.company_code = ''
      this.email = ''
      this.group_code = ''
      this.name = ''
      this.permissions = ['012','022','032']
      // this.permissions = []
      this.primary_contact = ''
      this.remark = ''
      this.role = ''
      this.secondary_contact = ''
      this.status = 'ACTIVE'
      this.username = ''
      this.password = ''
    },
    submitData () {
      let self = this
      this.$validator.validateAll().then(result => {
        if (result) {

          let formData = new FormData();

          if(self.name == ''){
            alert('Please enter name')
            return false
          }
          if(self.role == ''){
            alert('Please select role')
            return false
          }
          else{
            if(this.uuid !== ''){
              formData.append('_method', 'PUT' )
              formData.append('username', self.username )
              formData.append('name', self.name )
              formData.append('role', self.role )
              formData.append('group_code', self.group_code )
              formData.append('company_code', self.company_code )
              formData.append('primary_contact', self.primary_contact )
              formData.append('secondary_contact', self.secondary_contact )
              formData.append('email', self.email )
              formData.append('remark', self.remark )
              formData.append('status', self.status )
              formData.append('groupid', self.groupid )
              formData.append('permissions', self.role == 'SUPERADMIN' ? '*' : self.permissions.toString()  )
            } 
            else{
              formData.append('username', self.username )
              formData.append('password', self.password )
              formData.append('name', self.name )
              formData.append('role', self.role )
              formData.append('group_code', self.group_code )
              formData.append('company_code', self.company_code )
              formData.append('primary_contact', self.primary_contact )
              formData.append('secondary_contact', self.secondary_contact )
              formData.append('email', self.email )
              formData.append('remark', self.remark )
              formData.append('status', 'ACTIVE')
              formData.append('groupid', self.groupid )
              formData.append('permissions', self.role == 'SUPERADMIN' ? '*' : self.permissions.toString() )
            } 

            const obj = {
              uuid: this.uuid,
              name: this.name,
              role: this.role,
              group_code: this.group_code,
              company_code: this.company_code,
              primary_contact: this.primary_contact,
              secondary_contact: this.secondary_contact,
              email: this.email,
              remark: this.remark,
              status: this.status,
              groupid: this.groupid,
              permissions: this.role == 'SUPERADMIN' ? '*' : self.permissions.toString(),
              form_data: formData
            }

            if (this.uuid !== '') {
              this.$store.dispatch("userManagement/updateRecord", obj)
              .then(()   => { this.showUpdateSuccess() })
              .catch(err => { console.error(err)  })
            } else {
              this.$store.dispatch("userManagement/addRecord", obj)
              .then(()   => { this.showAddSuccess() })
              .catch(err => { console.error(err)  })
            }

            this.$emit('closeSidebar')
            this.initValues()
          }
        }
      })
    },
    showUpdateSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Updated',
        text: 'The selected user was successfully updated'
      })
    },
    showAddSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'New User Added',
        text: 'New user was successfully added'
      })
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    // addNewPermission(){
    //   this.permissions_list.push({
    //     permission_array: []
    //   })
    // },
    // removeThis(index){
    //   this.permissions_list.splice(index, 1);
    // }
  },
  created(){
    if (!this.isSidebarActiveLocal) return
    if (Object.entries(this.data).length === 0) {
      this.initValues()
      this.$validator.reset()

      if(this.user_info.role == 'SUPERADMIN'){
        this.role = 'PARTNER'
      }
      else if(this.user_info.role == 'PARTNER'){
        this.role = 'WORKER'
      }
    } else {

      let data = JSON.parse(JSON.stringify(this.data))

      this.created_at = data.created_at
      this.deleted_at = data.deleted_at
      this.updated_at = data.updated_at
      this.uuid = data.uuid
      this.company_code = data.company_code
      this.email = data.email
      this.group_code = data.group_code
      this.name = data.name
      this.groupid = data.groupid
      this.parent_name = data.name
      this.permissions = data.permissions.split(',')
      this.primary_contact = data.primary_contact
      this.remark = data.remark
      this.role = data.role
      this.secondary_contact = data.secondary_contact
      this.status = data.status
      this.username = data.username
      this.initValues()
    }

    // if(this.permissions_list.length <= 0){
    //   this.addNewPermission()
    // }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 500px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
